module.exports = __webpack_public_path__ + "img/bid-open-hall-head-light.9bb2e988.png";